import { render, staticRenderFns } from "./NotAyarlariList.vue?vue&type=template&id=3668af9e"
import script from "./NotAyarlariList.vue?vue&type=script&lang=ts"
export * from "./NotAyarlariList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports